// extracted by mini-css-extract-plugin
export default {"ThirdBlock":"ThirdBlock_ThirdBlock__5MIEB","skillsContainer":"ThirdBlock_skillsContainer__g-N3+","title":"ThirdBlock_title__2RgVy","paragraph":"ThirdBlock_paragraph__FVqpx"};